export const TEST = 'TEST';
export const SET_MOBILE_NAV_STATUS = 'SET_MOBILE_NAV_STATUS';

export const GET_USER_DATA_STARTED = 'GET_USER_DATA_STARTED';
export const GET_USER_DATA_SUCCESS = 'GET_USER_DATA_SUCCESS';
export const GET_USER_DATA_FAILURE = 'GET_USER_DATA_FAILURE';

export const GET_PRE_SALE_MAIN_STARTED = 'GET_PRE_SALE_MAIN_STARTED';
export const GET_PRE_SALE_MAIN_SUCCESS = 'GET_PRE_SALE_MAIN_SUCCESS';
export const GET_PRE_SALE_MAIN_FAILURE = 'GET_PRE_SALE_MAIN_FAILURE';

export const SET_PRE_SALE_BUY_MODAL_STATUS = 'SET_PRE_SALE_BUY_MODAL_STATUS';
export const SET_SETTINGS_CHANGE_PASSWORD_MODAL_STATUS = 'SET_SETTINGS_CHANGE_PASSWORD_MODAL_STATUS';

export const CHANGE_PASSWORD_STARTED = 'CHANGE_PASSWORD_STARTED';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';

export const SET_SETTINGS_CHANGE_WALLET_MODAL_STATUS = 'SET_SETTINGS_CHANGE_WALLET_MODAL_STATUS';

export const CHANGE_WALLET_STARTED = 'CHANGE_WALLET_STARTED';
export const CHANGE_WALLET_SUCCESS = 'CHANGE_WALLET_SUCCESS';
export const CHANGE_WALLET_FAILURE = 'CHANGE_WALLET_FAILURE';

export const GET_BUY_TOKEN_DATA_STARTED = 'GET_BUY_TOKEN_DATA_STARTED';
export const GET_BUY_TOKEN_DATA_SUCCESS = 'GET_BUY_TOKEN_DATA_SUCCESS';
export const GET_BUY_TOKEN_DATA_FAILURE = 'GET_BUY_TOKEN_DATA_FAILURE';

export const SET_SETTINGS_CHANGE_EMAIL_MODAL_STATUS = 'SET_SETTINGS_CHANGE_EMAIL_MODAL_STATUS';

export const CHANGE_EMAIL_STARTED = 'CHANGE_EMAIL_STARTED';
export const CHANGE_EMAIL_SUCCESS = 'CHANGE_EMAIL_SUCCESS';
export const CHANGE_EMAIL_FAILURE = 'CHANGE_EMAIL_FAILURE';

export const GET_LAST_LOG_STARTED = 'GET_LAST_LOG_STARTED';
export const GET_LAST_LOG_SUCCESS = 'GET_LAST_LOG_SUCCESS';
export const GET_LAST_LOG_FAILURE = 'GET_LAST_LOG_FAILURE';

export const LOGOUT_STARTED = 'LOGOUT_STARTED';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const LOGOUT_OTHERS_STARTED = 'LOGOUT_OTHERS_STARTED';
export const LOGOUT_OTHERS_SUCCESS = 'LOGOUT_OTHERS_SUCCESS';
export const LOGOUT_OTHERS_FAILURE = 'LOGOUT_OTHERS_FAILURE';

export const GET_ORDER_HISTORY_STARTED = 'GET_ORDER_HISTORY_STARTED';
export const GET_ORDER_HISTORY_SUCCESS = 'GET_ORDER_HISTORY_SUCCESS';
export const GET_ORDER_HISTORY_FAILURE = 'GET_ORDER_HISTORY_FAILURE';

export const GET_ACTIVE_ORDER_STARTED = 'GET_ACTIVE_ORDER_STARTED';
export const GET_ACTIVE_ORDER_SUCCESS = 'GET_ACTIVE_ORDER_SUCCESS';
export const GET_ACTIVE_ORDER_FAILURE = 'GET_ACTIVE_ORDER_FAILURE';

export const CANCEL_ORDER_STARTED = 'CANCEL_ORDER_STARTED';
export const CANCEL_ORDER_SUCCESS = 'CANCEL_ORDER_SUCCESS';
export const CANCEL_ORDER_FAILURE = 'CANCEL_ORDER_FAILURE';

export const GET_REFERRALS_STARTED = 'GET_REFERRALS_STARTED';
export const GET_REFERRALS_SUCCESS = 'GET_REFERRALS_SUCCESS';
export const GET_REFERRALS_FAILURE = 'GET_REFERRALS_FAILURE';

export const SET_REFERRER_STARTED = 'SET_REFERRER_STARTED';
export const SET_REFERRER_SUCCESS = 'SET_REFERRER_SUCCESS';
export const SET_REFERRER_FAILURE = 'SET_REFERRER_FAILURE';

export const SET_CAPSULE_QUESTIONNAIRE_MODAL_STATUS = 'SET_CAPSULE_QUESTIONNAIRE_MODAL_STATUS';
export const SET_CAPSULE_NOTES_MODAL_STATUS = 'SET_CAPSULE_NOTES_MODAL_STATUS';
export const SET_CAPSULE_FILES_MODAL_STATUS = 'SET_CAPSULE_FILES_MODAL_STATUS';
export const SET_CAPSULE_BUY_MODAL_STATUS = 'SET_CAPSULE_BUY_MODAL_STATUS';

export const GET_CAPSULE_STATS_STARTED = 'GET_CAPSULE_STATS_STARTED';
export const GET_CAPSULE_STATS_SUCCESS = 'GET_CAPSULE_STATS_SUCCESS';
export const GET_CAPSULE_STATS_FAILURE = 'GET_CAPSULE_STATS_FAILURE';

export const GET_QUESTIONNAIRE_STARTED = 'GET_QUESTIONNAIRE_STARTED';
export const GET_QUESTIONNAIRE_SUCCESS = 'GET_QUESTIONNAIRE_SUCCESS';
export const GET_QUESTIONNAIRE_FAILURE = 'GET_QUESTIONNAIRE_FAILURE';

export const SAVE_BLOCK_ANSWERS_STARTED = 'SAVE_BLOCK_ANSWERS_STARTED';
export const SAVE_BLOCK_ANSWERS_SUCCESS = 'SAVE_BLOCK_ANSWERS_SUCCESS';
export const SAVE_BLOCK_ANSWERS_FAILURE = 'SAVE_BLOCK_ANSWERS_FAILURE';

export const GET_CAPSULE_NOTES_STARTED = 'GET_CAPSULE_NOTES_STARTED';
export const GET_CAPSULE_NOTES_SUCCESS = 'GET_CAPSULE_NOTES_SUCCESS';
export const GET_CAPSULE_NOTES_FAILURE = 'GET_CAPSULE_NOTES_FAILURE';

export const SAVE_CAPSULE_NOTE_STARTED = 'SAVE_CAPSULE_NOTE_STARTED';
export const SAVE_CAPSULE_NOTE_SUCCESS = 'SAVE_CAPSULE_NOTE_SUCCESS';
export const SAVE_CAPSULE_NOTE_FAILURE = 'SAVE_CAPSULE_NOTE_FAILURE';

export const DELETE_CAPSULE_NOTE_STARTED = 'DELETE_CAPSULE_NOTE_STARTED';
export const DELETE_CAPSULE_NOTE_SUCCESS = 'DELETE_CAPSULE_NOTE_SUCCESS';
export const DELETE_CAPSULE_NOTE_FAILURE = 'DELETE_CAPSULE_NOTE_FAILURE';

export const GET_CAPSULE_FILES_STARTED = 'GET_CAPSULE_FILES_STARTED';
export const GET_CAPSULE_FILES_SUCCESS = 'GET_CAPSULE_FILES_SUCCESS';
export const GET_CAPSULE_FILES_FAILURE = 'GET_CAPSULE_FILES_FAILURE';

export const UPLOAD_CAPSULE_FILE_STARTED = 'UPLOAD_CAPSULE_FILE_STARTED';
export const UPLOAD_CAPSULE_FILE_SUCCESS = 'UPLOAD_CAPSULE_FILE_SUCCESS';
export const UPLOAD_CAPSULE_FILE_FAILURE = 'UPLOAD_CAPSULE_FILE_FAILURE';

export const SET_CAPSULE_FILE_UPLOAD_PROGRESS = 'SET_CAPSULE_FILE_UPLOAD_PROGRESS';
export const DELETE_CAPSULE_FILE_STARTED = 'DELETE_CAPSULE_FILE_STARTED';
export const DELETE_CAPSULE_FILE_SUCCESS = 'DELETE_CAPSULE_FILE_SUCCESS';

export const DELETE_CAPSULE_FILE_FAILURE = 'DELETE_CAPSULE_FILE_FAILURE';

export const GET_CAPSULE_OFFER_STARTED = 'GET_CAPSULE_OFFER_STARTED';
export const GET_CAPSULE_OFFER_SUCCESS = 'GET_CAPSULE_OFFER_SUCCESS';
export const GET_CAPSULE_OFFER_FAILURE = 'GET_CAPSULE_OFFER_FAILURE';

export const PURCHASE_CAPSULE_STARTED = 'PURCHASE_CAPSULE_STARTED';
export const PURCHASE_CAPSULE_SUCCESS = 'PURCHASE_CAPSULE_SUCCESS';
export const PURCHASE_CAPSULE_FAILURE = 'PURCHASE_CAPSULE_FAILURE';

export const SET_TOPUP_MODAL_STATUS = 'SET_TOPUP_MODAL_STATUS';

export const GET_DASHBOARD_STARTED = 'GET_DASHBOARD_STARTED';
export const GET_DASHBOARD_SUCCESS = 'GET_DASHBOARD_SUCCESS';
export const GET_DASHBOARD_FAILURE = 'GET_DASHBOARD_FAILURE';

export const CREATE_TOPUP_STARTED = 'CREATE_TOPUP_STARTED';
export const CREATE_TOPUP_SUCCESS = 'CREATE_TOPUP_SUCCESS';
export const CREATE_TOPUP_FAILURE = 'CREATE_TOPUP_FAILURE';

export const GET_TOPUP_STATUS_STARTED = 'GET_TOPUP_STATUS_STARTED';
export const GET_TOPUP_STATUS_SUCCESS = 'GET_TOPUP_STATUS_SUCCESS';
export const GET_TOPUP_STATUS_FAILURE = 'GET_TOPUP_STATUS_FAILURE';

export const CANCEL_TOPUP_STARTED = 'CANCEL_TOPUP_STARTED';
export const CANCEL_TOPUP_SUCCESS = 'CANCEL_TOPUP_SUCCESS';
export const CANCEL_TOPUP_FAILURE = 'CANCEL_TOPUP_FAILURE';

export const GET_SYSTEM_UPDATES_STARTED = 'GET_SYSTEM_UPDATES_STARTED';
export const GET_SYSTEM_UPDATES_SUCCESS = 'GET_SYSTEM_UPDATES_SUCCESS';
export const GET_SYSTEM_UPDATES_FAILURE = 'GET_SYSTEM_UPDATES_FAILURE';

export const GET_DIRECT_TOPUP_INFO_STARTED = 'GET_DIRECT_TOPUP_INFO_STARTED';
export const GET_DIRECT_TOPUP_INFO_SUCCESS = 'GET_DIRECT_TOPUP_INFO_SUCCESS';
export const GET_DIRECT_TOPUP_INFO_FAILURE = 'GET_DIRECT_TOPUP_INFO_FAILURE';

export const CREATE_DIRECT_TOPUP_STARTED = 'CREATE_DIRECT_TOPUP_STARTED';
export const CREATE_DIRECT_TOPUP_SUCCESS = 'CREATE_DIRECT_TOPUP_SUCCESS';
export const CREATE_DIRECT_TOPUP_FAILURE = 'CREATE_DIRECT_TOPUP_FAILURE';

export const GET_DIRECT_TOPUP_STARTED = 'GET_DIRECT_TOPUP_STARTED';
export const GET_DIRECT_TOPUP_SUCCESS = 'GET_DIRECT_TOPUP_SUCCESS';
export const GET_DIRECT_TOPUP_FAILURE = 'GET_DIRECT_TOPUP_FAILURE';

export const CANCEL_DIRECT_TOPUP_STARTED = 'CANCEL_DIRECT_TOPUP_STARTED';
export const CANCEL_DIRECT_TOPUP_SUCCESS = 'CANCEL_DIRECT_TOPUP_SUCCESS';
export const CANCEL_DIRECT_TOPUP_FAILURE = 'CANCEL_DIRECT_TOPUP_FAILURE';

export const GET_NOTIFICATIONS_STARTED = 'GET_NOTIFICATIONS_STARTED';
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_FAILURE = 'GET_NOTIFICATIONS_FAILURE';
export const READ_NOTIFICATION_SUCCESS = 'READ_NOTIFICATION_SUCCESS';
export const READ_ALL_NOTIFICATIONS_SUCCESS = 'READ_ALL_NOTIFICATIONS_SUCCESS';
export const GET_WITHDRAW_INFO_STARTED = 'GET_WITHDRAW_INFO_STARTED';
export const GET_WITHDRAW_INFO_SUCCESS = 'GET_WITHDRAW_INFO_SUCCESS';
export const GET_WITHDRAW_INFO_FAILURE = 'GET_WITHDRAW_INFO_FAILURE';
export const CREATE_WITHDRAW_STARTED = 'CREATE_WITHDRAW_STARTED';
export const CREATE_WITHDRAW_SUCCESS = 'CREATE_WITHDRAW_SUCCESS';
export const CREATE_WITHDRAW_FAILURE = 'CREATE_WITHDRAW_FAILURE';
export const GET_WITHDRAWS_STARTED = 'GET_WITHDRAWS_STARTED';
export const GET_WITHDRAWS_SUCCESS = 'GET_WITHDRAWS_SUCCESS';
export const GET_WITHDRAWS_FAILURE = 'GET_WITHDRAWS_FAILURE';
export const CANCEL_WITHDRAW_STARTED = 'CANCEL_WITHDRAW_STARTED';
export const CANCEL_WITHDRAW_SUCCESS = 'CANCEL_WITHDRAW_SUCCESS';
export const CANCEL_WITHDRAW_FAILURE = 'CANCEL_WITHDRAW_FAILURE';
export const SET_WITHDRAW_MODAL_STATUS = 'SET_WITHDRAW_MODAL_STATUS';

export const SET_REFERRAL_WITHDRAW_MODAL_STATUS = 'SET_REFERRAL_WITHDRAW_MODAL_STATUS';
export const GET_REFERRAL_WITHDRAW_INFO_STARTED = 'GET_REFERRAL_WITHDRAW_INFO_STARTED';
export const GET_REFERRAL_WITHDRAW_INFO_SUCCESS = 'GET_REFERRAL_WITHDRAW_INFO_SUCCESS';
export const GET_REFERRAL_WITHDRAW_INFO_FAILURE = 'GET_REFERRAL_WITHDRAW_INFO_FAILURE';
export const CREATE_REFERRAL_WITHDRAW_STARTED = 'CREATE_REFERRAL_WITHDRAW_STARTED';
export const CREATE_REFERRAL_WITHDRAW_SUCCESS = 'CREATE_REFERRAL_WITHDRAW_SUCCESS';
export const CREATE_REFERRAL_WITHDRAW_FAILURE = 'CREATE_REFERRAL_WITHDRAW_FAILURE';
export const GET_REFERRAL_WITHDRAWS_STARTED = 'GET_REFERRAL_WITHDRAWS_STARTED';
export const GET_REFERRAL_WITHDRAWS_SUCCESS = 'GET_REFERRAL_WITHDRAWS_SUCCESS';
export const GET_REFERRAL_WITHDRAWS_FAILURE = 'GET_REFERRAL_WITHDRAWS_FAILURE';
export const CANCEL_REFERRAL_WITHDRAW_STARTED = 'CANCEL_REFERRAL_WITHDRAW_STARTED';
export const CANCEL_REFERRAL_WITHDRAW_SUCCESS = 'CANCEL_REFERRAL_WITHDRAW_SUCCESS';

export const GET_REFERRAL_TRANSFERS_STARTED = 'GET_REFERRAL_TRANSFERS_STARTED';
export const GET_REFERRAL_TRANSFERS_SUCCESS = 'GET_REFERRAL_TRANSFERS_SUCCESS';
export const GET_REFERRAL_TRANSFERS_FAILURE = 'GET_REFERRAL_TRANSFERS_FAILURE';
export const CREATE_REFERRAL_TRANSFER_STARTED = 'CREATE_REFERRAL_TRANSFER_STARTED';
export const CREATE_REFERRAL_TRANSFER_SUCCESS = 'CREATE_REFERRAL_TRANSFER_SUCCESS';
export const CREATE_REFERRAL_TRANSFER_FAILURE = 'CREATE_REFERRAL_TRANSFER_FAILURE';
export const CANCEL_REFERRAL_TRANSFER_STARTED = 'CANCEL_REFERRAL_TRANSFER_STARTED';
export const CANCEL_REFERRAL_TRANSFER_SUCCESS = 'CANCEL_REFERRAL_TRANSFER_SUCCESS';
export const CANCEL_REFERRAL_TRANSFER_FAILURE = 'CANCEL_REFERRAL_TRANSFER_FAILURE';
export const SET_REFERRAL_TRANSFER_MODAL_STATUS = 'SET_REFERRAL_TRANSFER_MODAL_STATUS';
export const SET_REFERRAL_TRANSFERS_MODAL_STATUS = 'SET_REFERRAL_TRANSFERS_MODAL_STATUS';

export const REQUEST_EARLY_ACCESS_STARTED = 'REQUEST_EARLY_ACCESS_STARTED';
export const REQUEST_EARLY_ACCESS_SUCCESS = 'REQUEST_EARLY_ACCESS_SUCCESS';
export const REQUEST_EARLY_ACCESS_FAILURE = 'REQUEST_EARLY_ACCESS_FAILURE';

export const SET_STORAGE_MODAL_STATUS = 'SET_STORAGE_MODAL_STATUS';
export const GET_STORAGE_STARTED = 'GET_STORAGE_STARTED';
export const GET_STORAGE_SUCCESS = 'GET_STORAGE_SUCCESS';
export const GET_STORAGE_FAILURE = 'GET_STORAGE_FAILURE';
export const GET_STORAGE_PACKAGES_STARTED = 'GET_STORAGE_PACKAGES_STARTED';
export const GET_STORAGE_PACKAGES_SUCCESS = 'GET_STORAGE_PACKAGES_SUCCESS';
export const GET_STORAGE_PACKAGES_FAILURE = 'GET_STORAGE_PACKAGES_FAILURE';
export const CREATE_STORAGE_PURCHASE_STARTED = 'CREATE_STORAGE_PURCHASE_STARTED';
export const CREATE_STORAGE_PURCHASE_SUCCESS = 'CREATE_STORAGE_PURCHASE_SUCCESS';
export const CREATE_STORAGE_PURCHASE_FAILURE = 'CREATE_STORAGE_PURCHASE_FAILURE';
export const GET_STORAGE_PURCHASE_SUCCESS = 'GET_STORAGE_PURCHASE_SUCCESS';
export const CANCEL_STORAGE_PURCHASE_SUCCESS = 'CANCEL_STORAGE_PURCHASE_SUCCESS';

export const GET_AVATAR_STARTED = 'GET_AVATAR_STARTED';
export const GET_AVATAR_SUCCESS = 'GET_AVATAR_SUCCESS';
export const GET_AVATAR_FAILURE = 'GET_AVATAR_FAILURE';

export const GET_VOICE_STARTED = 'GET_VOICE_STARTED';
export const GET_VOICE_SUCCESS = 'GET_VOICE_SUCCESS';
export const GET_VOICE_FAILURE = 'GET_VOICE_FAILURE';
export const UPLOAD_VOICE_STARTED = 'UPLOAD_VOICE_STARTED';
export const UPLOAD_VOICE_SUCCESS = 'UPLOAD_VOICE_SUCCESS';
export const UPLOAD_VOICE_FAILURE = 'UPLOAD_VOICE_FAILURE';

export const GET_ENERGY_STARTED = 'GET_ENERGY_STARTED';
export const GET_ENERGY_SUCCESS = 'GET_ENERGY_SUCCESS';
export const GET_ENERGY_FAILURE = 'GET_ENERGY_FAILURE';
export const UNLOCK_ENERGY_STARTED = 'UNLOCK_ENERGY_STARTED';
export const UNLOCK_ENERGY_SUCCESS = 'UNLOCK_ENERGY_SUCCESS';
export const UNLOCK_ENERGY_FAILURE = 'UNLOCK_ENERGY_FAILURE';
export const GET_METAPERSON_STARTED = 'GET_METAPERSON_STARTED';
export const GET_METAPERSON_SUCCESS = 'GET_METAPERSON_SUCCESS';
export const GET_METAPERSON_FAILURE = 'GET_METAPERSON_FAILURE';
export const IMPORT_AVATAR_STARTED = 'IMPORT_AVATAR_STARTED';
export const IMPORT_AVATAR_SUCCESS = 'IMPORT_AVATAR_SUCCESS';
export const IMPORT_AVATAR_FAILURE = 'IMPORT_AVATAR_FAILURE';
export const SET_UNLOCK_MODAL_STATUS = 'SET_UNLOCK_MODAL_STATUS';
export const SET_ENERGY_MODAL_STATUS = 'SET_ENERGY_MODAL_STATUS';
export const SET_CREATOR_STATUS = 'SET_CREATOR_STATUS';

export const GET_ENERGY_PACKAGES_STARTED = 'GET_ENERGY_PACKAGES_STARTED';
export const GET_ENERGY_PACKAGES_SUCCESS = 'GET_ENERGY_PACKAGES_SUCCESS';
export const GET_ENERGY_PACKAGES_FAILURE = 'GET_ENERGY_PACKAGES_FAILURE';
export const CREATE_ENERGY_PURCHASE_STARTED = 'CREATE_ENERGY_PURCHASE_STARTED';
export const CREATE_ENERGY_PURCHASE_SUCCESS = 'CREATE_ENERGY_PURCHASE_SUCCESS';
export const CREATE_ENERGY_PURCHASE_FAILURE = 'CREATE_ENERGY_PURCHASE_FAILURE';
export const GET_ENERGY_PURCHASE_SUCCESS = 'GET_ENERGY_PURCHASE_SUCCESS';
export const CANCEL_ENERGY_PURCHASE_SUCCESS = 'CANCEL_ENERGY_PURCHASE_SUCCESS';

export const ASK_CONVERSATION_STARTED = 'ASK_CONVERSATION_STARTED';
export const ASK_CONVERSATION_SUCCESS = 'ASK_CONVERSATION_SUCCESS';
export const ASK_CONVERSATION_FAILURE = 'ASK_CONVERSATION_FAILURE';
export const SPEAK_CONVERSATION_STARTED = 'SPEAK_CONVERSATION_STARTED';
export const SPEAK_CONVERSATION_SUCCESS = 'SPEAK_CONVERSATION_SUCCESS';
export const SPEAK_CONVERSATION_FAILURE = 'SPEAK_CONVERSATION_FAILURE';
export const GET_CONVERSATIONS_STARTED = 'GET_CONVERSATIONS_STARTED';
export const GET_CONVERSATIONS_SUCCESS = 'GET_CONVERSATIONS_SUCCESS';
export const GET_CONVERSATIONS_FAILURE = 'GET_CONVERSATIONS_FAILURE';
export const GET_CONVERSATION_STARTED = 'GET_CONVERSATION_STARTED';
export const GET_CONVERSATION_SUCCESS = 'GET_CONVERSATION_SUCCESS';
export const GET_CONVERSATION_FAILURE = 'GET_CONVERSATION_FAILURE';

export const SEAL_CAPSULE_STARTED = 'SEAL_CAPSULE_STARTED';
export const SEAL_CAPSULE_SUCCESS = 'SEAL_CAPSULE_SUCCESS';
export const SEAL_CAPSULE_FAILURE = 'SEAL_CAPSULE_FAILURE';
export const SET_SEAL_MODAL_STATUS = 'SET_SEAL_MODAL_STATUS';
